import React from 'react';

import { DatePicker } from 'redux-form-material-ui';
import { Field, reduxForm } from 'redux-form';

import FlatButton from 'material-ui/FlatButton';

import * as validator from 'helpers/Validator';
import { AccentColor } from 'helpers/AccentColorHelper';
import * as format from 'helpers/Formatter';
import { colors } from 'helpers/ColorHelper';

let delayPaymentForm = props => {
  const { handleSubmit } = props;

  return (
    <div>
      <form onSubmit={handleSubmit.bind(this)} id="form_field">
        <div className="row">
          <div className="col-xs-12" style={{ margin: 'auto' }}>
            <Field
              name="payment_delay_date"
              component={DatePicker}
              style={{
                marginTop: '-20px',
                fontSize: '14px',
                textAlign: 'left',
                width: '100%',
              }}
              formatDate={format.reformatDate}
              autoOk={true}
              textFieldStyle={{ width: '100%', fontSize: '14px' }}
              floatingLabelText="Payment Delay Date"
              validate={[validator.required]}
              minDate={new Date()}
            />
          </div>
        </div>
        <div
          className="row"
          style={{
            textAlign: 'center',
            margin: 'auto',
            marginTop: '10px',
            marginBottom: '10px',
          }}
        >
          <FlatButton
            label="Delay Payment"
            type="submit"
            className="Delay Payment"
            primary={true}
            hoverColor="grey"
            style={{ color: 'white', height: '40px' }}
            disabled={props.isSubmitting}
            backgroundColor={props.isSubmitting ? colors.GRAY : AccentColor()}
          />
        </div>
      </form>
    </div>
  );
};

delayPaymentForm = reduxForm({
  form: 'delay_payment_form', // a unique identifier for this form
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
})(delayPaymentForm);

export default delayPaymentForm;
